var SoundEffectManager = require("sound-effect-manager")

var sm = new SoundEffectManager()

// load some files by passing it a url and a name
sm.loadFile("/audio/ding.wav", "ding")
sm.loadFile("/audio/pop.wav", "pop")
sm.loadFile("/audio/happy.wav", "happy")
sm.loadFile("/audio/epic.wav", "epic")
sm.loadFile("/audio/beep.mp3", "beep")
sm.loadFile("/audio/beep1.mp3", "beep1")

export default (play) => sm.play(play)
